import React from 'react';
import Header from './VerticalLayout/Header';
import Sidebar from './VerticalLayout/Sidebar';
import Footer from './VerticalLayout/Footer';

const Layout = (props) => {
  return (
    <>
      <div className="container-fluid">
        <div id="layout-wrapper">
          <Header />
          <Sidebar />
          <div className="main-content">
            {props.children}
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default Layout;
